import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Battlestar Galactica - best video novel ever",
  "description": "",
  "published": "2009-03-31T00:00:00.000Z",
  "redirect_from": ["/blog/battlestar-galactica-best-video-novel-ever/swizec/471"],
  "categories": "art, review, Television, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Over the past few months, difficult to say just how many, I've been watching a lot of `}<a parentName="p" {...{
        "href": "http://www.scifi.com/battlestar/",
        "title": "Battlestar Galactica"
      }}>{`Battlestar Galactica`}</a>{` on my computer. Seems when I finally found out about this marvelous show I had a good three years of catching up to do and let me tell you something. It. Was. Worth. It! `}<img parentName="p" {...{
        "src": "https://blogs.seattleweekly.com/threadcount/cylon6.jpg",
        "alt": null,
        "title": "Cylon number six"
      }}></img>{` Seriously, Battlestar Galactica is the best television series in all history of television series, it's better even than `}<a parentName="p" {...{
        "href": "http://alpha.cbs.com/primetime/big_bang_theory/",
        "title": "The Big Bang Theory"
      }}>{`The Big Bang Theory`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/House_%28TV_series%29",
        "title": "House (TV series)"
      }}>{`House MD`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/MacGyver",
        "title": "MacGyver"
      }}>{`McGyver`}</a>{`. MUCH better! What really sets this show apart is that it's not classically American in that it doesn't rely on dashingly good looking actors, cheap humor or anything that makes television the crap that it is.`}</p>
    <p>{`To be honest, most of Galactica's actors are rather average looking (except for the cylon babes of course), nothing you wouldn't find in an average gym, especially the pilots and other military personel. Sure they're well built and whatnot, but they aren't dashingly good looking. Even the humor is, surprise surprise, human. Never feels written, never feels repetitive and boring, just looks like plain and simple everyday arsing around.`}</p>
    <p>{`But that's not really what I love about Battlestar Galactica. What I REALLY love is the story. The story is fucking brilliant. Humans have a war with the Cylons, their creations with an overly developed sense of enslavement, their planets get nuked into oblivion and those who by some odd chance survive ... leave in search of earth.`}</p>
    <p>{`The brilliance here is that we're actually only a few decades away from something like that happening on our own planet! And what's more, in the series finale, after many somewhat predictable twists and turns we find out that the story isn't that of a future. Not even that of a future reimagined and change in a few terms to make it seem like fiction. Oh no, it's the story of our history. Everything, absolutely everything, we see on the show culminates in the humans landing on our Earth 150 `}<em parentName="p">{`thousand`}</em>{` years ago and starting anew with the tribal humans already on the planet.`}</p>
    <p>{`Now the interesting bit here is how nicely all of this ties up with factual history. Fact is, we know humans on earth at some point made a huge fucking jump from hunter-gatherer tribes to building pyramids and having large-scale civilizations. This of course hasn't happened 150k years ago, but still, astounding stuff.`}</p>
    <p>{`All I want to know after watching this marvelous show start to end is where can I buy this novel in book form? I want to read this thing as a book.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/b32d328f-b889-45d5-acd3-a7ff873b122c/",
        "title": "Zemified by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=b32d328f-b889-45d5-acd3-a7ff873b122c",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      